module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_15.a99061e8.webp";